import { ApiShipmentCollectionStatusResponse, CollectionStatus } from 'src/app/core/models';

export const getShipmentCollectionStatus = (): ApiShipmentCollectionStatusResponse => {
  return {
    patientId: 1000,
    shipmentId: 1001,
    collectionAmount: 100,
    status: CollectionStatus.PortalPaidBalanceAndCopay,
  };
};

export const setShipmentCollectionStatus = () => {};
